<div class="stepper">
  <div class="step">
    <div class="step-image government-id" [class.valid]="validSteps > 0"></div>
    <h3 [class.valid]="validSteps > 0">Identification</h3>
  </div>
  <hr class="divider" />
  <div class="step" [class.disabled]="currentStep < 2">
    <div class="step-image person" [class.valid]="validSteps > 1"></div>
    <h3>Picture</h3>
  </div>
  <hr class="divider" />
  <div class="step" [class.disabled]="currentStep < 3">
    <div class="step-image check" [class.valid]="validSteps > 2"></div>
    <h3>Verification</h3>
  </div>
</div>
